import React from 'react'
import PropTypes from 'prop-types'
import {VStack} from '@chakra-ui/react'
import {Component} from '@salesforce/commerce-sdk-react/components'
import {PDCLink} from '../../assets'
import {useIntl} from 'react-intl'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useMultiSite from '../../../hooks/use-multi-site'
import {ACCOUNT_ORDERS_URL, TRACK_MY_ORDER_URL} from '../../../constants'
/**
 * PDC Header Navigation Links
 * @param {object} regions - Regions
 * @returns {JSX.Element} - PDC Header Navigation Links component
 */
export const PDCCheckoutHeaderHelpLinks = ({regions}) => {
    let components = []
    if (regions) {
        components = regions[0].components || []
    }
    const {formatMessage} = useIntl()
    const {data: customer} = useCurrentCustomer()
    const trackMyOrderURL = customer.isRegistered ? ACCOUNT_ORDERS_URL : TRACK_MY_ORDER_URL
    const {buildUrl} = useMultiSite()

    return (
        components && (
            <VStack as="ul" listStyleType="none" spacing={'16px'} align="flex-start">
                {components.map((component, index) => {
                    return (
                        <li key={component?.id || index}>
                            <Component component={component} />
                        </li>
                    )
                })}
                <li>
                    <PDCLink
                        url={buildUrl(trackMyOrderURL)}
                        label={formatMessage({
                            id: 'help_link.trackmyorder',
                            defaultMessage: 'Track my order'
                        })}
                    />
                </li>
            </VStack>
        )
    )
}

PDCCheckoutHeaderHelpLinks.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object,
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
